import { SET_FOCUSED } from "./types";
export var setFocused = function (focused) {
  return {
    type: SET_FOCUSED,
    focused: focused
  };
};